export default {
    mobile: 'example: 091212345678',
    phone: 'example: 021********',
    
}